import * as React from 'react';
import { MesoDisplayAd } from './meso-display-ad';
import { DisplayAd } from 'constants/ads';
export const MesoSideRail = React.memo(() => React.createElement(React.Fragment, null, React.createElement(MesoDisplayAd, Object.assign({}, DisplayAd.SIDERAIL_R1)), React.createElement(MesoDisplayAd, Object.assign({}, DisplayAd.SIDERAIL_R2))));
MesoSideRail.displayName = 'MesoSideRail';